import { render, staticRenderFns } from "./Adicionar.vue?vue&type=template&id=db925bca&"
import script from "./Adicionar.vue?vue&type=script&lang=js&"
export * from "./Adicionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports